import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, useTheme } from '@mui/material'
import { East } from '@mui/icons-material'
import { AgentMode } from '@/index'
import { BaseBadge } from './BaseBadge'

interface AgentModeBadgeTransitionProps {
  readonly from: AgentMode
  readonly to: AgentMode
}

export const AgentModeBadgeTransition: FC<AgentModeBadgeTransitionProps> = ({ from, to }) => {
  const theme = useTheme()

  return (
    <Box sx={transitionContainerSx}>
      <BaseBadge mode={from} size="small" />
      <East sx={transitionArrowSx(theme)} />
      <BaseBadge mode={to} size="small" animated />
    </Box>
  )
}

const transitionContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
}

const transitionArrowSx = (theme: Theme): SxProps<Theme> => ({
  fontSize: '1rem',
  color: theme.palette.text.primary,
})
